import { Destination } from "../models/destination";
import { Location } from "../models/location";
import { ITEM_DESTINATION_COLOR } from "./enums";

export const getColorByDestination = (
  destination?: Destination,
  destinationResidence?: Location
) => {
  if (destinationResidence) {
    return ITEM_DESTINATION_COLOR.Residence;
  }
  if (destination && destination?.color) {
    return destination?.color;
  }

  return ITEM_DESTINATION_COLOR.None;
};
